import React from "react";
import Button from "../../../ui/button";
import styles from "./styles.module.scss";
import { clsx } from "clsx";
import { ICounterPage } from "./types";

interface IBaseStep {
  nextStep?: () => void;
  yesStep?: () => void;
  noStep?: () => void;
  prevStep?: () => void;
  counterPage?: ICounterPage;
  isNextStepDisabled?: boolean;
  nextButtonLabel?: string;
  yesButtonLabel?: string;
  noButtonLabel?: string;
  isRowYes?: boolean;
  text?: string;
  children?: React.ReactElement | React.ReactElement[];
  position?: { top?: number; bottom?: number; right?: number; left?: number };
}

const BaseStep = ({
  isNextStepDisabled,
  nextButtonLabel,
  yesButtonLabel,
  noButtonLabel,
  position,
  children,
  text,
  isRowYes,
  counterPage,
  nextStep,
  prevStep,
  yesStep,
  noStep,
}: IBaseStep) => {
  return (
    <div className={styles.baseStep}>
      <div className={styles.baseStep__container}>
        {text && <div className={styles.baseStep__text}>{text}</div>}

        {children && (
          <div className={clsx(styles.baseStep__children)}>{children}</div>
        )}

        <div
          className={clsx(
            styles.baseStep__buttons,
            position && styles.baseStep__buttons_absolute,
            !prevStep && styles.baseStep__buttons_noGap,
            prevStep &&
              yesStep &&
              !nextStep &&
              !noStep &&
              styles.baseStep__buttons_row
          )}
          style={position ? { ...position } : undefined}
        >
          <div className={styles.baseStep__nextPrev}>
            {prevStep && (
              <div className={styles.baseStep__button}>
                <Button
                  isRowLeft
                  variant="gray"
                  label={nextButtonLabel ? nextButtonLabel : "Назад"}
                  onClick={() => prevStep()}
                />
              </div>
            )}
            {nextStep && (
              <div className={styles.baseStep__button}>
                <Button
                  disabled={isNextStepDisabled}
                  isRowRight
                  label={nextButtonLabel ? nextButtonLabel : "Далее"}
                  onClick={() => nextStep()}
                />
              </div>
            )}
          </div>

          {yesStep && (
            <div className={styles.baseStep__yesNoBlock}>
              {noStep && (
                <div className={styles.baseStep__button}>
                  <Button
                    label={noButtonLabel ? noButtonLabel : "Нет"}
                    variant="dark"
                    onClick={() => noStep()}
                  />
                </div>
              )}
              <div className={styles.baseStep__button}>
                <Button
                  label={yesButtonLabel ? yesButtonLabel : "Да"}
                  isRowRight={isRowYes}
                  onClick={() => yesStep()}
                />
              </div>
            </div>
          )}
        </div>
        {counterPage && (
          <div className={styles.baseStep__counterPage}>
            <p>
              {counterPage?.current} / {counterPage?.max}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseStep;
